<div class="dashboard">
  <h2>Interaction Outcome Distribution</h2>

  <div class="filters">
    <mat-form-field appearance="outline">
      <mat-label>Start Date</mat-label>
      <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate">
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>End Date</mat-label>
      <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate">
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>

    <button mat-raised-button color="primary" (click)="fetchOutcomeDistribution()">
      Update View
    </button>
  </div>

  <mat-tab-group class="analytics-tabs">
    <mat-tab label="Outcome Visual Breakdown">
      <mat-card-content style="height: 400px; padding: 20px;">
        <canvas baseChart 
          [data]="barChartData" 
          [options]="barChartOptions" 
          [type]="'bar'">
        </canvas>
      </mat-card-content>
    </mat-tab>

    <mat-tab label="Data Details">
      <table mat-table [dataSource]="tableData" class="mat-elevation-z8 styled-table">
        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef> Category </th>
          <td mat-cell *matCellDef="let row"> {{ row.conversation_category }} </td>
        </ng-container>

        <ng-container matColumnDef="outcome">
          <th mat-header-cell *matHeaderCellDef> Outcome </th>
          <td mat-cell *matCellDef="let row"> {{ row.interaction_outcome }} </td>
        </ng-container>

        <ng-container matColumnDef="count">
          <th mat-header-cell *matHeaderCellDef> Count </th>
          <td mat-cell *matCellDef="let row"> {{ row.count }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['category', 'outcome', 'count']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['category', 'outcome', 'count'];"></tr>
      </table>
    </mat-tab>
  </mat-tab-group>
</div>